/**
 * Form Input State Handler
 * 
 * Adds "filled" class to .input-group parent when input/textarea has a value
 * 
 * @package EVT Restaurant Builder
 * @since 1.0.0
 */

export default function initFormInputState() {
    // Function to check and update filled state
    function updateFilledState(input) {
        const inputGroup = input.closest('.input-group');
        if (!inputGroup) return;

        if (input.value.trim() !== '') {
            inputGroup.classList.add('filled');
        } else {
            inputGroup.classList.remove('filled');
        }
    }

    // Get all inputs and textareas within .input-group
    const inputs = document.querySelectorAll('.input-group input, .input-group textarea, .input-group select');

    inputs.forEach(input => {
        // Check initial state on page load
        updateFilledState(input);

        // Update on input event (real-time)
        input.addEventListener('input', () => {
            updateFilledState(input);
        });

        // Update on change event (for select elements)
        input.addEventListener('change', () => {
            updateFilledState(input);
        });

        // Add focused class on focus
        input.addEventListener('focus', () => {
            const inputGroup = input.closest('.input-group');
            if (inputGroup) {
                inputGroup.classList.add('focused');
            }
        });

        // Remove focused class and update filled state on blur
        input.addEventListener('blur', () => {
            const inputGroup = input.closest('.input-group');
            if (inputGroup) {
                inputGroup.classList.remove('focused');
            }
            updateFilledState(input);
        });
    });

    // Handle dynamically added form fields (using MutationObserver)
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) { // Element node
                    // Check if the added node is an input-group or contains input-groups
                    const newInputs = node.matches?.('.input-group input, .input-group textarea, .input-group select')
                        ? [node]
                        : node.querySelectorAll?.('.input-group input, .input-group textarea, .input-group select') || [];

                    newInputs.forEach(input => {
                        updateFilledState(input);
                        
                        input.addEventListener('input', () => {
                            updateFilledState(input);
                        });
                        
                        input.addEventListener('change', () => {
                            updateFilledState(input);
                        });
                        
                        input.addEventListener('focus', () => {
                            const inputGroup = input.closest('.input-group');
                            if (inputGroup) {
                                inputGroup.classList.add('focused');
                            }
                        });
                        
                        input.addEventListener('blur', () => {
                            const inputGroup = input.closest('.input-group');
                            if (inputGroup) {
                                inputGroup.classList.remove('focused');
                            }
                            updateFilledState(input);
                        });
                    });
                }
            });
        });
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}
